import { render, staticRenderFns } from "./WrapperHeader.vue?vue&type=template&id=6bc0c584&scoped=true&"
import script from "./WrapperHeader.vue?vue&type=script&lang=js&"
export * from "./WrapperHeader.vue?vue&type=script&lang=js&"
import style0 from "./WrapperHeader.vue?vue&type=style&index=0&id=6bc0c584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0c584",
  null
  
)

export default component.exports